// The product reviews (sections/product-reviews.liquid, class ch-reviews): the cards come from the page reviews-api in
// the visitor's locale when the dropdown first opens, newest first, 5 more a click, filtered by a click on a star bar;
// a customer's photo opens full screen. The words and the locale root = data- of #reviews-accordion. Loaded with
// defer; run again when the theme editor reloads the section.
(function () {
  function run() {
    const accordion = document.getElementById('reviews-accordion');
    const reviewsList = document.getElementById('reviews-list');
    const loadMoreBtn = document.getElementById('amazon-load-more');
    const btnWrapper = document.getElementById('ajax-pagination-wrapper');
    const noReviewsMsg = document.getElementById('no-reviews-msg');
    const filtersContainer = document.getElementById('star-filters-container');
    const starLinks = document.querySelectorAll('.star-bar-link');

    if (!accordion || !reviewsList) return;
    const S = accordion.dataset;

    let allReviews = [];
    let isLoaded = false;
    let visibleLimit = 5;
    let activeFilter = null;

    const getSafeRating = (val) => {
      let parsed = parseInt(String(val).charAt(0));
      let rating = isNaN(parsed) ? 5 : parsed;
      if (rating === 0) rating = 5;
      return Math.max(1, Math.min(5, rating));
    };

    async function fetchReviews() {
      try {
        reviewsList.innerHTML = '<div class="pr-loading">' + S.loading + '</div>';
        // The locale root: «/» on the English storefront, «/ru» on the Russian one. With no prefix the api page always
        // renders in English: English product names and /products/ links instead of /ru/products/.
        const localeRoot = S.root.replace(/\/$/, '');
        // preview_theme_id only on an unpublished theme (data-preview-theme): Shopify's default robots.txt disallows
        // any URL with it, and Googlebot could not fetch the reviews when it renders the page.
        const preview = S.previewTheme ? '&preview_theme_id=' + S.previewTheme : '';
        const response = await fetch(localeRoot + '/pages/reviews-api?view=reviews-api' + preview + '&nocache=' + Date.now());
        if (!response.ok) throw new Error('Network response failed');

        allReviews = await response.json();
        isLoaded = true;
        renderReviews();
      } catch (error) {
        reviewsList.innerHTML = '<p class="pr-error">' + S.error + '</p>';
      }
    }

    function renderReviews() {
      reviewsList.innerHTML = '';

      // 1. The star filter
      let filteredReviews = activeFilter !== null
        ? allReviews.filter(r => {
          let rVal = typeof r.rating === 'object' ? (r.rating.value || r.rating) : r.rating;
          return getSafeRating(rVal) === activeFilter;
        })
        : [...allReviews];

      // 2. Newest first
      filteredReviews.sort((a, b) => {
        const dateA = (a.date && a.date !== 'null') ? new Date(a.date).getTime() : 0;
        const dateB = (b.date && b.date !== 'null') ? new Date(b.date).getTime() : 0;
        return dateB - dateA;
      });

      // 3. The cards shown so far
      const reviewsToDisplay = filteredReviews.slice(0, visibleLimit);

      if (reviewsToDisplay.length === 0) {
        noReviewsMsg.style.display = 'block';
        if (btnWrapper) btnWrapper.style.display = 'none';
        return;
      }
      noReviewsMsg.style.display = 'none';

      const html = reviewsToDisplay.map(review => {
        let ratingVal = typeof review.rating === 'object' ? (review.rating.value || review.rating) : review.rating;
        const stars = getSafeRating(ratingVal);
        const emptyStars = 5 - stars;

        const starHtml = '<span class="pr-card__star">★</span>'.repeat(stars) +
          '<span class="pr-card__star pr-card__star--off">☆</span>'.repeat(emptyStars);

        const reviewText = (review.body && review.body !== 'null') ? review.body.replace(/\n/g, '<br>') : '';

        let metaInfo = [];
        if (review.country && review.country !== 'null') metaInfo.push(S.country.replace('{country}', review.country));
        if (review.date && review.date !== 'null') metaInfo.push(S.date.replace('{date}', review.date));
        const reviewMetaHtml = metaInfo.length > 0
          ? `<div class="pr-card__meta">${S.reviewed} ${metaInfo.join(' ')}</div>`
          : '';

        const deliveryHtml = (review.delivery && review.delivery !== 'null')
          ? `<div class="pr-card__delivery">${S.delivery.replace('{days}', review.delivery)}</div>`
          : '';

        let productsHtml = '';
        if (review.products && review.products.length > 0) {
          productsHtml = `<div class="pr-card__products">` +
            review.products.map(p => `
            <a href="${p.url}" target="_blank" rel="noopener noreferrer" class="pr-card__product">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
              <span>${p.title}</span>
            </a>
          `).join('') +
            `</div>`;
        }

        return `
      <div class="review-card">
        <div class="pr-card__head">
          <strong class="pr-card__author">${review.author}</strong>
          <span class="pr-card__sep">|</span>
          <span class="pr-card__badge">${S.verified}</span>
        </div>

        <div class="pr-card__stars">
          ${starHtml}
        </div>

        ${reviewMetaHtml}
        ${deliveryHtml}

        <div class="pr-card__text">
          ${reviewText}
        </div>

        ${review.image_url && review.image_url !== 'null' ? `
        <div class="pr-card__photos">
          <img class="review-thumbnail"
             src="${review.image_url}"
             data-full-image="${review.image_url}"
             alt="${S.photoAlt}" loading="lazy">
        </div>
        ` : ''}

        ${productsHtml}
      </div>`;
      }).join('');

      reviewsList.innerHTML = html;

      if (btnWrapper) {
        btnWrapper.style.display = visibleLimit < filteredReviews.length ? 'block' : 'none';
      }
    }

    accordion.addEventListener('toggle', async () => {
      if (accordion.open && !isLoaded) {
        await fetchReviews();
      }
    });
    // A dropdown opened before this deferred script ran fired its toggle unheard
    if (accordion.open && !isLoaded) fetchReviews();

    if (filtersContainer) {
      filtersContainer.addEventListener('click', function (e) {
        const link = e.target.closest('.star-bar-link');
        if (!link) return;
        e.preventDefault();

        const starVal = parseInt(link.getAttribute('data-star'));
        activeFilter = (activeFilter === starVal) ? null : starVal;
        visibleLimit = 5;

        starLinks.forEach(l => {
          if (!activeFilter) {
            l.style.opacity = '1';
          } else if (parseInt(l.getAttribute('data-star')) === activeFilter) {
            l.style.opacity = '1';
          } else {
            l.style.opacity = '0.3';
          }
        });

        renderReviews();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        visibleLimit += 5;
        renderReviews();
      });
    }

    const lightbox = document.getElementById('review-lightbox');
    const lightboxImg = document.getElementById('review-lightbox-img');

    reviewsList.addEventListener('click', function (e) {
      if (e.target.classList.contains('review-thumbnail')) {
        const fullSizeUrl = e.target.getAttribute('data-full-image');
        if (fullSizeUrl) {
          lightboxImg.src = fullSizeUrl;
          lightbox.style.display = 'flex';
        }
      }
    });

    if (lightbox) {
      lightbox.addEventListener('click', function () {
        lightbox.style.display = 'none';
        lightboxImg.src = '';
      });
    }
  }

  run();
  document.addEventListener('shopify:section:load', run);
})();
